import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import { clone } from '@chegg/utils';
import { checkoutClient, isEmpty, modifyCountriesData, CHEGG, Component, Namespace, StatusTypes, SharedCommandNames, fireStatusUpdate, setCallback } from '@chegg/commerce-utils';
import { StoreBuilder } from '../../utils/ReduxStoreUtil';
import { executeCommands } from '../../redux/CommandState/CommandState.actions';
import { saveConfigs } from '../../redux/ConfigState/ConfigState.slice';
import { CheggBaseUrlProduction, AppDevConfigs } from '../../constants/AppConstants';
import UserAddressWrapper from '../../views/UserAddressWrapper/UserAddressWrapper';
var UserAddress = function UserAddress(_ref) {
  var config = _ref.config,
    callback = _ref.callback,
    commands = _ref.commands;
  var authorization = config.authorization,
    _config$mandatoryCoun = config.mandatoryCountries,
    mandatoryCountries = _config$mandatoryCoun === void 0 ? [] : _config$mandatoryCoun;
  var cheggBaseUrl = authorization.cheggBaseUrl;
  setCallback(callback, Namespace.USER_ADDRESS);
  var store = StoreBuilder().getStore({
    config: config
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    authorized = _useState2[0],
    setAuthorized = _useState2[1];
  useEffect(function () {
    initializeApp();
    initializeSDK();
    StoreBuilder().resetStore(config);
  }, []);
  useEffect(function () {
    executeCommandsFromProps();
  });
  var executeCommandsFromProps = function executeCommandsFromProps() {
    if (commands && !isEmpty(commands)) {
      store.dispatch(executeCommands(commands));
    }
  };
  var initializeApp = function initializeApp() {
    // need to refresh localstorage before initialize app to get updated data
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(CHEGG.UA.COUNTRY_DATA);
    }
    var newCountriesData = modifyCountriesData(mandatoryCountries);

    // need to stringify with spread operator as JSON does not support to stringify Map data
    //https://stackoverflow.com/questions/29085197/how-do-you-json-stringify-an-es6-map

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(CHEGG.UA.COUNTRY_DATA,
      //@ts-ignore
      JSON.stringify(_toConsumableArray(newCountriesData)));
    }
    if (cheggBaseUrl && cheggBaseUrl !== CheggBaseUrlProduction) {
      store.dispatch(saveConfigs({
        appConstants: AppDevConfigs
      }));
    }
  };
  var initializeSDK = function initializeSDK() {
    // Initialize checkout sdk by calling authorize
    var initStatus = checkoutClient.authorize(clone(authorization));
    if (!initStatus.success) {
      var errors = initStatus.errors;
      // Notify user that authorization failed
      fireStatusUpdate([{
        status: StatusTypes.ERROR,
        command: SharedCommandNames.AUTHORIZE,
        payload: {
          component: Component.APP,
          //@ts-ignore
          errors: errors
        }
      }], Namespace.USER_ADDRESS);
    } else {
      setAuthorized(true);
      fireStatusUpdate([{
        status: StatusTypes.SUCCESS,
        command: SharedCommandNames.AUTHORIZE,
        payload: {
          component: Component.APP
        }
      }], Namespace.USER_ADDRESS);
    }
  };
  return authorized ? /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(UserAddressWrapper, null)) : null;
};
export default UserAddress;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/external/UserAddress/index.js
// module id = 4408
// module chunks = 11